import type { AxiosInstance } from 'axios'
import axios from 'axios'

import storeConfig from '../../store.config'
import { handleAxiosError } from './handleAxiosError'

const { servicesWorkspace } = storeConfig

type CreateServicesClientOptions = {
  account: 'decathlonstore' | 'decathlonstoreapp'
}

function createServicesClient(
  options?: CreateServicesClientOptions
): AxiosInstance {
  const baseURL = options?.account
    ? `https://${servicesWorkspace}--${options?.account}.myvtex.com`
    : undefined

  const instance = axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
    },
  })

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      handleAxiosError(error)

      return Promise.reject(error)
    }
  )

  return instance
}

const clientStore = createServicesClient({ account: 'decathlonstore' })
const clientStoreApp = createServicesClient({ account: 'decathlonstoreapp' })
const axiosClient = createServicesClient()

export { clientStore, clientStoreApp, axiosClient }
